import { Component, HostListener, OnInit, AfterViewInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ConsultationService } from '../../services/consultation.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, AfterViewInit {
  private consultationService = inject(ConsultationService);
  
  isScrolled = signal<boolean>(false);
  mobileMenuOpen = signal<boolean>(false);
  activeSection = signal<string>('home');
  isAdminLoggedIn = signal<boolean>(false);

  ngOnInit() {
    this.checkAdminAuth();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setupScrollSpy();
      this.updateActiveSectionOnScroll();
    }, 300);
  }

  checkAdminAuth() {
    if (typeof window !== 'undefined' && window.localStorage) {
      const token = localStorage.getItem('ambition_admin_token');
      this.isAdminLoggedIn.set(!!token);
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (typeof window !== 'undefined') {
      this.isScrolled.set(window.scrollY > 40);
      this.updateActiveSectionOnScroll();
    }
  }

  updateActiveSectionOnScroll() {
    if (typeof window === 'undefined') return;
    const sectionIds = ['home', 'about', 'services', 'projects', 'process', 'contact'];
    const scrollPos = window.scrollY + 220;

    for (let i = sectionIds.length - 1; i >= 0; i--) {
      const el = document.getElementById(sectionIds[i]);
      if (el && el.offsetTop <= scrollPos) {
        if (this.activeSection() !== sectionIds[i]) {
          this.activeSection.set(sectionIds[i]);
        }
        break;
      }
    }
  }

  setupScrollSpy() {
    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) return;

    const sectionIds = ['home', 'about', 'services', 'projects', 'process', 'contact'];
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.activeSection.set(entry.target.id);
        }
      });
    }, {
      rootMargin: '-20% 0px -50% 0px',
      threshold: 0.1
    });

    sectionIds.forEach(id => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
  }

  setActive(sectionId: string) {
    this.activeSection.set(sectionId);
    this.closeMobileMenu();
  }

  toggleMobileMenu() {
    this.mobileMenuOpen.update(v => !v);
  }

  closeMobileMenu() {
    this.mobileMenuOpen.set(false);
  }

  openConsultationModal() {
    this.consultationService.openModal();
    this.closeMobileMenu();
  }
}
